import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { DirtyTouchedInvalidErrorStateMatcher } from '@y42/angular/forms';
import { connectState, InputObservable } from '@y42/angular/util';
import { isNotNullish } from '@y42/util/nullish';
import { BehaviorSubject, filter, map, merge, Observable, switchMap } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'y42-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitleComponent {
  @Input()
  @InputObservable()
  formControl!: FormControl<string>;
  formControl$!: Observable<FormControl<string> | undefined>;

  readonly inputMaxLength = 90;
  readonly errorMatcher = new DirtyTouchedInvalidErrorStateMatcher();

  private readonly blurInput$$ = new BehaviorSubject<void>(undefined);

  readonly state = connectState(this, {
    formControlErrors: merge(
      this.blurInput$$.pipe(
        switchMap(() => this.formControl$),
        filter(isNotNullish),
      ),
      this.formControl$.pipe(
        filter(isNotNullish),
        switchMap((formControl) => formControl.statusChanges.pipe(map(() => formControl))),
      ),
    ).pipe(map((formControl) => (this.errorMatcher.isErrorState(formControl) ? formControl.errors : null))),
  });

  onBlurInput() {
    this.blurInput$$.next();
  }
}
